<template>
   <div class="AddTemplateOvelray container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc cursor-pointer" v-on:click="closeAddTemplateOverlay($event)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              
              <div class="row  margin-bottom-1Perc margin-top-1Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="col-md-1 col-lg-1 text-align-right Padding-left-0px">
                  Template Name
                </div>
                <div class="col-md-4 col-lg-4">
                   <div class="form-group">
                      <input class="form-control" type="text" v-model="templateNameValue">
                   </div>
                </div>
                <div class="col-md-1 col-lg-1 text-align-right">
                  Email Subject
                </div>
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <input class="form-control" type="text" v-model="emailSubjectValue">
                    </div>
                </div>
              </div>
              <div class="row margin-top-3Perc">
                 <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                 <div class="col-lg-1 text-align-right">Content</div>
                 <div class="col-md-10 col-lg-10 Padding-left-0px">
                    <div class="form-group">
                       <div class="col-xs-11 col-sm-11 col-md-11 col-lg-11">
                         <!-- <vue-editor v-model="templateContentValue" :editorToolbar="customToolbar"></vue-editor> -->
                         <tinymce id="d1" v-model="templateContentValue"></tinymce>
                       </div>
                    </div>
                 </div>
              </div>
              <div class="row margin-top-2Perc">
                 <div class="col-sm-1 col-md-1 col-lg-1"></div>
                 <div class="col-sm-1 col-md-1 col-lg-1 text-align-right">Keywords</div>
                 <div class="col-sm-9 col-md-9 col-lg-9 text-left" v-if="templateTypeValue === parseInt(constants.EmailTemplateType.Normal)">{{normalTemplateKeywords}}</div>
                 <div class="col-sm-9 col-md-9 col-lg-9 text-left" v-if="templateTypeValue === parseInt(constants.EmailTemplateType.Progression)">{{progressionTemplateKeywords}}</div>
                 <div class="col-sm-9 col-md-9 col-lg-9 text-left" v-if="templateTypeValue === parseInt(constants.EmailTemplateType.Dashboard_Email)">{{emailDashboardTemplateKeywords}}</div>
                 <div class="col-sm-1 col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-top-2Perc" v-if="templateTypeValue === parseInt(constants.EmailTemplateType.Progression) || templateTypeValue === parseInt(constants.EmailTemplateType.Dashboard_Email)">
                 <div class="col-sm-1 col-md-1 col-lg-1"></div>
                 <div class="col-sm-1 col-md-1 col-lg-1 text-align-right">Progress Keywords</div>
                 <div class="col-sm-9 col-md-9 col-lg-9 text-left">{{(templateTypeValue === parseInt(constants.EmailTemplateType.Progression)) ? courseProgressKeywords : emailDashboardProgressKeywords}}</div>
                 <div class="col-sm-1 col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-top-2Perc" v-if="templateTypeValue === parseInt(constants.EmailTemplateType.Progression) || templateTypeValue === parseInt(constants.EmailTemplateType.Dashboard_Email)">
                 <div class="col-sm-1 col-md-1 col-lg-1"></div>
                 <div class="col-sm-1 col-md-1 col-lg-1 text-align-right">Progress Help tip</div>
                 <div class="col-sm-9 col-md-9 col-lg-9 text-left" v-html="(templateTypeValue === parseInt(constants.EmailTemplateType.Progression)) ? progressionTemplateHelpTip : emailDashboardTemplateHelpTip"></div>
                 <div class="col-sm-1 col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-top-2Perc margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createTemplate">Create Template</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    </div> 
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { VueEditor } from 'vue2-quill-editor'
import AlertBox from '@/components/AlertOverlay'
import { constants } from '@/utils/constants'
import { templateService } from '@/server-util/template-service'
import tinymce from 'vue-tinymce-editor'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  name: 'AddTemplateOvelray',
  props: ['templateType'],
  created () {
    if (this.templateType === undefined || this.templateType === null) {
      this.templateTypeValue = parseInt(constants.EmailTemplateType.Normal)
    } else {
      this.templateTypeValue = this.templateType
    }
  },
  data: function () {
    return {
      constants: constants,
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      templateName: '',
      emailSubject: '',
      templateContent: '',
      emailTemplateType: 0,
      // eslint-disable-next-line
      normalTemplateKeywords: '{Course}, {firstname}, {lastname}, {email}, {loginid}, {set_password}, {total_progress}, {time_remaining}, {progress_remaining}, {certificate_link}',
      // eslint-disable-next-line
      progressionTemplateKeywords: '{firstname}, {lastname}, {email}, {loginid}',
      // eslint-disable-next-line
      emailDashboardTemplateKeywords: '{firstname}, {lastname}, {email}, {loginid}',
      // eslint-disable-next-line
      courseProgressKeywords: '{StartTable}, {CourseImage}, {CourseName:label_CourseName}, {CourseProgress:label_CourseProgress}, {Enrolled_On:label_EnrolledOn}, {CourseEnds:label_CourseEnds}, {EndTable}',
      // eslint-disable-next-line
      emailDashboardProgressKeywords: '{StartTable}, {CourseImage}, {CourseName:label_CourseName}, Participants:Participants}, {LoggedIn:LoggedIn}, {Engaged:Engaged}, {Range:80,50-79,20-49,1-19,0}, {EndTable}',
      // eslint-disable-next-line
      progressionTemplateHelpTip: 'Fields starting with <b>label_</b> should be replaced with <b>custom column names</b> in the template. <br/>For eg : <b>{CourseName:label_CourseName}</b> can be used like <b>{CourseName: Enrolled Courses}</b>, and <b>{CourseProgress:label_CourseProgress}</b> can be used like <b>{CourseName:Your Progress}</b> etc.',
      emailDashboardTemplateHelpTip: '- Instead of Specifiy a range, If you mention a single number in the template then records will be fetch for that particular percentage only.<br/>- If you want progress such as <b>X%-above</b> then replace <b>X%</b> with the actual lower limit and <b>above</b> with upper limit.<br/>&nbsp;&nbsp;For eg: <b>{Range:80,50-79,20-49,1-19,0}</b> or <b>{Range:80-100,50-79,20-49,1-19,0}</b> etc.',
      isTemplateCreatedSuccessfully: false,
      customToolbar: [
      ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'image', 'video', 'formula', {'color': []}, {'background': []}],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      [{'align': []}, 'link'],
      [{'header': [1, 2, 3, 4, 5, 6, false]}, {'font': []}],
      [{'script': 'sub'}, {'script': 'super'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{ 'direction': 'rtl' }],
      ['clean']
      ]
    }
  },
  components: {
    'alert-box': AlertBox,
    VueEditor,
    'loader': Loader,
    'tinymce': tinymce
  },
  methods: {
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      // AK: If given message is created successfully msg, then close overlay on cancel click
      if (this.isTemplateCreatedSuccessfully) {
        this.isTemplateCreatedSuccessfully = false
        this.$emit('closeOverlay', false)
      }
    },
    closeAddTemplateOverlay: function (event) {
      this.$emit('closeOverlay', false)
    },
    createTemplate: function () {
      var storeObj = this.$store
      if (this.checkRequiredFieldsBeforePost()) {
        const orgContent = dmAdminUtils.removeTFromUrls(this.templateContent)
        this.templateContent = orgContent
        const formData = new FormData()
        formData.append('EmailTemplateName', this.templateNameValue)
        formData.append('EmailSubject', this.emailSubjectValue)
        formData.append('EmailTemplateText', this.templateContentValue)
        formData.append('TemplateType', this.templateTypeValue)
        if (formData !== null) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          templateService
            .createTemplate(
              storeObj.state.access_token, formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // console.log(JSON.stringify(responseObj.data))
                // AK: Store it as per user EmailType in respective data
                switch (this.templateTypeValue) {
                  case parseInt(constants.EmailTemplateType.Normal):
                    storeObj.state.templateList.push(responseObj.data)
                    break
                  case parseInt(constants.EmailTemplateType.Progression):
                    storeObj.state.progressionTemplateList.push(responseObj.data)
                    break
                  case parseInt(constants.EmailTemplateType.Dashboard_Email):
                    storeObj.state.emailDashboardTemplateList.push(responseObj.data)
                    break
                }
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = '\'' + this.templateNameValue + '\' template created successfully.'
                this.isTemplateCreatedSuccessfully = true
              } else {
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              this.showAlertDialog = true
              // this.showSpinner = false
              this.$store.state.isLoading = false
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'FormData is NULL hence declined CREATE NEW TEMPLATE OPERATION'
          )
        }
      }
    },
    checkRequiredFieldsBeforePost: function () {
      if (this.templateNameValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Name can\'t be empty.'
        return false
      } else if (this.emailSubjectValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Subject can\'t be empty.'
        return false
      } else if (this.stripHtml(this.templateContentValue).trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Content can\'t be empty.'
        return false
      }
      return true
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    }
  },
  computed: {
    templateContentValue: {
      get: function () {
        return this.templateContent
      },
      set: function (newValue) {
        this.templateContent = newValue
        // console.log('templateContentValue >>> ' + this.templateContent)
      }
    },
    templateNameValue: {
      get: function () {
        return this.templateName
      },
      set: function (newValue) {
        this.templateName = newValue
      }
    },
    emailSubjectValue: {
      get: function () {
        return this.emailSubject
      },
      set: function (newValue) {
        this.emailSubject = newValue
      }
    },
    templateTypeValue: {
      get: function () {
        return this.emailTemplateType
      },
      set: function (newValue) {
        this.emailTemplateType = newValue
      }
    }
  }
}
</script>

<style scoped>
.AddTemplateOvelray {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.img-circle {
    border-radius: 75px;
}
.background-color {
  background-color: #d4d4d4;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.img-circle {
    border-radius: 75px;
}
.background-color {
  background-color: #d4d4d4;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.opacity-75{
  opacity: 75;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex !important;
  align-items: center !important;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.margin-bottom-1Perc {
  margin-bottom: 1%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.user-img-width-height {
  width: 150px;
  height: 150px;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
.Padding-left-0px{
  padding-left: 0%;
}
.margin-top-0Point5Perc{
  margin-top:0.5% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/emails/template/AddTemplateOverlay.vue